import { toast, ToastOptions } from "react-toastify";

// Extend the options interface and omit the 'type' property from ToastOptions
interface ShowToastOptions extends Omit<ToastOptions, "type"> {
    message: string;
    type: "success" | "error" | "warn" | "info"; // Explicitly allow 'warn' here
}

export const showToast = ({ message, type, ...options }: ShowToastOptions) => {
    if (!message || !type) {
        console.error("Message or type is missing");
        return;
    }
    const getToastStyle = (type: ShowToastOptions["type"]) => {
        switch (type) {
            case "success":
                return {
                    backgroundColor: "#E6FFED",
                    color: "#2E7D32",
                    fontSize: "12px"
                };
            case "warn":
                return {
                    backgroundColor: "#FFF4E5",
                    color: "#F57C00",
                    fontSize: "12px"
                };
            case "error":
                return {
                    backgroundColor: "#FDECEA",
                    color: "#D32F2F",
                    fontSize: "12px"
                };
            case "info":
                return {
                    backgroundColor: "#E3F2FD",
                    color: "#0288D1",
                    fontSize: "12px"
                };
            default:
                return {
                    fontSize: "12px"
                };
        }
    };

    // Default options for toast notifications, with small font size
    const defaultOptions: ToastOptions = {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: getToastStyle(type)
    };

    // Merge custom options with default options
    const toastOptions = { ...defaultOptions, ...options };

    // Show different types of toast based on 'type'
    switch (type) {
        case "success":
            toast.success(message, toastOptions);
            break;
        case "error":
            toast.error(message, toastOptions);
            break;
        case "warn":
            toast.warn(message, toastOptions);
            break;
        case "info":
            toast.info(message, toastOptions);
            break;
        default:
            toast(message, toastOptions);
            break;
    }
};
